import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { QuoteVersions } from '../../../quote/alpaca/model/quote/quote_versions.model';
import { QuoteService } from '../../../quote/quote.service';
import { AlQuoteService } from '../../../quote/alpaca/al-quote/al-quote.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from "@angular/router";
import { GridOptions } from "ag-grid-community";
import { NgForm } from '@angular/forms';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-al-policy-full-details',
  templateUrl: './policy-full-details.component.html',
  styleUrls: ['../../../quote/quote.component.css'],
})
export class AlPolicyFullDetailsComponent implements OnInit {
  @Input() quoteData: QuoteVersions;
  editType = 'fullRow';

  constructor(private quoteService: AlQuoteService, private modalService: NgbModal, 
    private route: ActivatedRoute, private adminQuoteService: QuoteService,
    private sessionSt: LocalStorageService) {

  }

  quote;
  ngOnChanges(changes: SimpleChanges) {
    this.quote = this.quoteData;
    if (this.quote.company_id) {
      this.sessionSt.store('al_broker_company_id', this.quote.company_id);
      // GET STATIC DATA
      this.quoteService.getStaticData()
        .subscribe(
          (response: any) => {
            if (response.success) {
              if (response.result.alpaca_liability) {
                response.result.alpaca_liability.forEach((res) => {
                  res.is_checked = false;
                })
              }
              this.alpacaLiabiities = response.result.alpaca_liability;
              this.setLiabilityLimitValues();

              //Trailer Security
              this.traierSecurity = response.result.trailer_security;
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }

    this.setLiabilityLimitValues();

    // API - GET ENDORSEMENT
    if (this.quote &&  this.quote.id) {
      this.adminQuoteService.getEndorsement(this.quote.id)
      .subscribe(
        (response: any) => {
          this.rowData = response.result;
        });
    }
  }

  alpacaLiabiities;
  traierSecurity;
  ngOnInit(): void {

  }

  /*
  * Set Liability Limit Financials
  */
  setLiabilityLimitValues() {
    if (this.quote.alpaca_liability && this.alpacaLiabiities) {
      switch (this.quote.alpaca_liability.public_liability_cover) {
        case 1:
          this.alpacaLiabiities = this.alpacaLiabiities.filter(x => x.indeminity_limit == '1 Million');
          break;
        case 2:
          this.alpacaLiabiities = this.alpacaLiabiities.filter(x => x.indeminity_limit == '2 Million');
          break;
        case 5:
          this.alpacaLiabiities = this.alpacaLiabiities.filter(x => x.indeminity_limit == '5 Million');
          break;
      }

      this.alpacaLiabiities.forEach((res) => {
        let id = res.id;
        if ((id == '52f635f8-c5c6-41ad-a75a-463f82b73a0e' || id == '62f635f8-c5c6-41ad-a75a-463f82b73a0e' || id == '72f635f8-c5c6-41ad-a75a-463f82b73a0e') && this.quote.smallholding_activities.is_alpaca_experience_sessions == 1) {
          res.is_checked = true;
        }
        if ((id == '53f635f8-c5c6-41ad-a75a-463f82b73a0e' || id == '63f635f8-c5c6-41ad-a75a-463f82b73a0e' || id == '73f635f8-c5c6-41ad-a75a-463f82b73a0e') && this.quote.smallholding_activities.is_group_visits_insured_premises == 1) {
          res.is_checked = true;
        }
        if ((id == '54f635f8-c5c6-41ad-a75a-463f82b73a0e' || id == '64f635f8-c5c6-41ad-a75a-463f82b73a0e' || id == '74f635f8-c5c6-41ad-a75a-463f82b73a0e') && this.quote.smallholding_activities.is_visits_external_venues == 1) {
          res.is_checked = true;
        }
        if ((id == '56f635f8-c5c6-41ad-a75a-463f82b73a0e' || id == '66f635f8-c5c6-41ad-a75a-463f82b73a0e' || id == '76f635f8-c5c6-41ad-a75a-463f82b73a0e') && this.quote.smallholding_activities.is_promoting_selling_products == 1) {
          res.is_checked = true;
        }
        if ((id == '55f635f8-c5c6-41ad-a75a-463f82b73a0e' || id == '65f635f8-c5c6-41ad-a75a-463f82b73a0e' || id == '75f635f8-c5c6-41ad-a75a-463f82b73a0e') && this.quote.smallholding_activities.is_attending_events_trade_stand == 1) {
          res.is_checked = true;
        }

      });
    }
  }

  // ENDORSEMENT
  gridOptions: GridOptions = {
    onGridReady: () => {
      this.gridOptions.api.sizeColumnsToFit();
      var cellDefs = this.gridOptions.api.getEditingCells();
    }


  };
  columnDefs = [
    { headerName: 'Title', field: 'title', sortable: true, width: 200, editable: true },
    {
      headerName: 'Endorsement', field: 'endorsement_text', sortable: true, editable: false,
      cellRenderer: function (param) {
        return param.data.endorsement_text.replace('\r\n','<br>');
      },
      tooltip: function (param) {
        return param.data.endorsement_text;
      },
    },
  ];
  rowData: any;
  selectedRow;
  defaultColDef = {
    flex: 1,
    wrapText: true,
    autoHeight: true,
    sortable: true,
    resizable: true,
  };
  onColumnResized(params) {
    params.api.resetRowHeights();
  }


}
